import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ImageSlot } from "@/components/ImageSlot";
import { Seo } from "@/components/Seo";
import { api, fileUrl } from "@/lib/api";

export default function Brands() {
  const [brands, setBrands] = useState([]);
  const [authBrands, setAuthBrands] = useState([]);
  useEffect(() => {
    api.get("/brands").then((r) => setBrands(r.data || [])).catch(() => {});
    api.get("/authorized-brands").then((r) => setAuthBrands(r.data || [])).catch(() => {});
  }, []);

  const byCat = (c) => authBrands.filter((b) => b.category === c);

  return (
    <div data-testid="brands-page">
      <Seo title="Boat & Marine Brands | MTM Marine, Bristol, TN" description="Shop Falcon Boats and Armada Pontoons plus authorized Yamaha, Suzuki, Power-Pole, Monster Marine, and Sea Clear Power products at MTM Marine in Bristol, TN." />
      <section className="bg-mtm-charcoal text-white py-14">
        <div className="max-w-7xl mx-auto px-4">
          <p className="text-xs font-bold uppercase tracking-widest text-mtm-teal-bright font-mono">Our Brands</p>
          <h1 className="text-4xl sm:text-5xl font-extrabold font-heading tracking-tight mt-2">Boat Brands We Carry</h1>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 py-14 grid grid-cols-1 md:grid-cols-2 gap-6">
        {brands.map((b) => (
          <div key={b.key} className="rounded-2xl border border-slate-200 bg-white overflow-hidden shadow-sm">
            <ImageSlot label={b.hero_slot} dimensions="1000 × 500" aspect="aspect-[2/1]" className="rounded-none border-0" />
            <div className="p-6">
              <h2 className="font-heading font-bold text-2xl text-mtm-purple-deep">{b.name}</h2>
              <p className="text-slate-600 mt-2">{b.short_description}</p>
              <Button asChild className="mt-4 bg-mtm-purple hover:bg-mtm-purple-deep text-white rounded-full"><Link to={`/brands/${b.key}`}>Explore {b.name} <ChevronRight size={16} /></Link></Button>
            </div>
          </div>
        ))}
      </section>

      <section className="bg-white border-y border-slate-200 py-14">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="font-heading font-bold text-2xl text-slate-900 mb-8 text-center">Authorized Engine & Product Brands</h2>
          {["engine", "product"].map((cat) => byCat(cat).length > 0 && (
            <div key={cat} className="mb-8">
              <p className="text-xs font-bold uppercase tracking-widest text-slate-500 font-mono mb-4">{cat === "engine" ? "Engines" : "Marine Products"}</p>
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
                {byCat(cat).map((b) => (
                  <div key={b.id} className="bg-mtm-bg rounded-lg border border-slate-200 h-24 flex items-center justify-center p-3 text-center">
                    {b.logo_path ? (
                      <img src={fileUrl(b.logo_path, 260)} alt={b.name} className="max-h-14 max-w-full object-contain" />
                    ) : (
                      <span className="text-sm font-mono font-semibold text-slate-600">{b.name}</span>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
